import { createContext, use } from "react";
import {
    FieldValues,
    FormProvider,
    FormProviderProps,
    Mode
} from "react-hook-form";

type OmniFormContextValue = {
    mode?: Mode;
};

type OmniFormContextProviderProps<
    TFieldValues extends FieldValues,
    TContext = any,
    TTransformedValues = TFieldValues
> = FormProviderProps<TFieldValues, TContext, TTransformedValues> & {
    mode?: Mode;
};

export const OmniFormContext = createContext<OmniFormContextValue | undefined>(
    undefined
);
OmniFormContext.displayName = "OmniFormContext";

export const OmniFormContextProvider = <
    TFieldValues extends FieldValues,
    TContext = any,
    TTransformedValues = TFieldValues
>({
    mode,
    children,
    ...methods
}: OmniFormContextProviderProps<
    TFieldValues,
    TContext,
    TTransformedValues
>) => {
    return (
        <OmniFormContext value={{ mode }}>
            <FormProvider {...methods}>{children}</FormProvider>
        </OmniFormContext>
    );
};

export const useOmniFormContext = () => {
    const context = use<OmniFormContextValue | undefined>(OmniFormContext);

    return context ?? {};
};
